import { styled } from '../../../../../../../core/theme/styled';

export const StyledLink = styled.a`
  color: ${(props) => props.theme.palette.primary.main};
`;
